module.exports = __webpack_public_path__ + "static/media/instagram.994e1eea.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/social-logos/instagram.png
// module id = 131
// module chunks = 0